import { getRequestContext } from './server/request-context';

export function getUserAgent() {
  return __BROWSER__ ? navigator.userAgent : getRequestContext().honoContext.req.header('user-agent')!;
}
export function isTouch() {
  if (!__BROWSER__ && __DEV__) {
    console.warn('Can only detect touch device in the browser');
    return false;
  }

  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

let isCurrentScrollBar: boolean;
export function isScrollBar() {
  return isCurrentScrollBar || (isCurrentScrollBar = __BROWSER__ && window.innerWidth > document.body.offsetWidth);
}

export function isIOS() {
  return /iPad|iPhone|iPod/.test(getUserAgent());
}

export function isLandscape() {
  return __BROWSER__ && window.screen.width > window.screen.height;
}

export function isPortrait() {
  return __BROWSER__ && !isLandscape();
}

export function isEdge() {
  return /Edge/.test(getUserAgent());
}

export function isFF() {
  return /Firefox/.test(getUserAgent());
}

export function isSF(userAgent?: string) {
  return /^((?!chrome|android).)*safari/i.test(userAgent ?? getUserAgent());
}

export function isChrome() {
  return /Chrome/.test(getUserAgent());
}

export function getSafariVersion(userAgent?: string) {
  const matchVersion = (userAgent ?? getUserAgent()).match(/version\/(\d*\.?\d*)/i);
  return matchVersion !== null ? Number(matchVersion[1]) : 0;
}
